// @ts-nocheck
 
/* eslint-disable react/no-unknown-property */
 
/* eslint-disable react/self-closing-comp */
 
/* eslint-disable padding-line-between-statements, import/order, spaced-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-newline */
/* eslint-disable react/button-has-type */
 
 
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useIntl } from 'react-intl';
import { useHistory, useParams } from 'react-router-dom';
import { Box, CircularProgress, Typography, IconButton } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const EditFareMedia = () => {

  const currentLanguageCode = localStorage.getItem('EASY_MOBILITY_LANGUAGE') || 'en-us';
  const intl = useIntl();
  const history = useHistory();
  const { id } = useParams();
  const query = new URLSearchParams(history.location.search);
  const came_from = query.get('came_from'); // Get "id" parameter
  console.log(came_from);
  
  // State variables
  const [merchent_ID, setMerchantId] = useState(null);

  const [merchants, setMerchants] = useState([]);
  const [statuses, setStatuses] = useState([]);

  const [uid, setuid] = useState('');
  const [serial_num, setserial_num] = useState('');
  const [fare_media_type_id, setfare_media_type_id] = useState('');
  const [init_balance, setinit_balance] = useState(0);
  const [fare_media_issuer_id, setfare_media_issuer_id] = useState('');
  const [organisation_id, setorganisation_id] = useState('');
  const [fare_media_batch_label, setfare_media_batch_label] = useState('');
  const [passengers_group_id, setpassengers_group_id] = useState('');
  const [original_group_id, setOriginal_group_id] = useState('');
  const [selling_price, setselling_price] = useState(0);
  const [blacklist_note, setblacklist_note] = useState('');
  const [is_blacklist, setis_blacklist] = useState(null);
  const [group_change_reason, setgroup_change_reason] = useState('');

  const [fareMediaTypes, setFareMediaTypes] = useState([]);
  const [fareMediaIssuers, setFareMediaIssuers] = useState([]);
  const [organisations, setOrganisations] = useState([]);
  const [passengersGroups, setPassengersGroups] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [isFormLoading, setIsFormLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMerchantsDataLoading, setIsMerchantsDataLoading] = useState(false);
  const [fareMediaIssuersLoading, setFareMediaIssuersLoading] = useState(false);
  const [organisationsLoading, setOrganisationsLoading] = useState(false);
  const [fareMediaTypesLoading, setFareMediaTypesLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
//
const [from_portal, setFrom_portal] = useState(null);

  let userPersonalData = '';
  let userAuthData = '';
  const authData = localStorage.getItem('authData');

  if (authData !== null) {
    const parsedAuthData = JSON.parse(authData);
    userPersonalData = parsedAuthData.userData;
    userAuthData = parsedAuthData.userToken;
  }
  const fetchFareMedia = async () => {
    setIsFormLoading(true);
    setError(null);
    try {
      const url = `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/faremedia/get_fare_media`;
      const response = await axios.post(
        url,
        { fare_media_id: id },
        {
          headers: {
            'access-token': userAuthData?.access_token,
            uid: userAuthData?.uid,
            client: userAuthData?.client,
          },
        }
      );
      const fare_media = response.data.data;
      setuid(fare_media.uid);
      setserial_num(fare_media.serial_num);

      setfare_media_type_id(fare_media.fare_media_type_id);
      setinit_balance(fare_media.init_balance);
      setfare_media_issuer_id(fare_media.fm_issuer_id);
      setorganisation_id(fare_media.org_id);
      setfare_media_batch_label(fare_media.fare_media_batch_label || '');
      setpassengers_group_id(fare_media.passengers_group_id || '');
      setOriginal_group_id(fare_media.passengers_group_id || '');
      setselling_price(fare_media.selling_price);
      setblacklist_note(fare_media.blacklisted_note);
      setis_blacklist(fare_media.is_blacklisted);
      setFrom_portal(fare_media.from_portal);
    } catch (error) {
      setError(`Failed to fetch fare_media [${error}]`);
      toast.error(`Failed to fetch fare_media [${error}]`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
      });
    } finally {
      setIsFormLoading(false);
    }
  };
  const fetchFareMediaIssuers = async () => {
    setFareMediaIssuersLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/faremedia/get_fare_media_issuers`, {
        headers: {
          'access-token': userAuthData?.access_token,
          uid: userAuthData?.uid,
          client: userAuthData?.client,
        },
      });
      setFareMediaIssuers(response.data.data);
    } catch (error) {
      toast.error(`Failed to get fare media issuers [${error}]`);
    } finally {
      setFareMediaIssuersLoading(false);
    }
  };
  const fetchOrganisations = async () => {
    setOrganisationsLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/faremedia/get_organisations`, {
        headers: {
          'access-token': userAuthData?.access_token,
          uid: userAuthData?.uid,
          client: userAuthData?.client,
        },
      });
      setOrganisations(response.data.data);
    } catch (error) {
      toast.error(`Failed to get organisations [${error}]`);
    } finally {
      setOrganisationsLoading(false);
    }
  };
  const fetchFareMediaTypes = async () => {
    setFareMediaTypesLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/faremedia/get_fare_media_types`, {
        headers: {
          'access-token': userAuthData?.access_token,
          uid: userAuthData?.uid,
          client: userAuthData?.client,
        },
      });
      setFareMediaTypes(response.data.data);
    } catch (error) {
      toast.error(`Failed to get fare media types [${error}]`);
    } finally {
      setFareMediaTypesLoading(false);
    }
  };

  const fetchPassengersGroupsAndBatches = async () => {
    try {
      const groupRes = await axios.get(`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/passengers_groups?pageSize=1000`, {
        headers: {
          'access-token': userAuthData?.access_token,
          uid: userAuthData?.uid,
          client: userAuthData?.client,
        },
      });
      setPassengersGroups(groupRes.data.data.passengersGroups || []);
    } catch (error) {
      toast.error(`Failed to get groups or batches`);
    }
  };

  useEffect(() => {
    fetchFareMedia();
    fetchFareMediaIssuers();
    fetchOrganisations();
    fetchFareMediaTypes();
    fetchPassengersGroupsAndBatches();
  }, []);
//update fare media
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    
    try {
      const url = `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/fareMedia/update_fare_media`;
      const response = await axios.post(
        url,
         {
          fare_media_wanted_updated_id: id,
          blacklist_note: blacklist_note ? blacklist_note.trim() : blacklist_note,
          is_blacklist: is_blacklist,
        },
        {
          headers: {
            'access-token': userAuthData?.access_token,
            uid: userAuthData?.uid,
            client: userAuthData?.client,
          },
        }
      );

      toast.success('fare Media updated successfully!', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        toastStyle: {
          backgroundColor: '#F1662D',
          color: 'white',
        },
      });
      history.push( came_from && came_from == "one" 
        ? `/CardsManagement/fareMedia/${id}`:
        `/CardsManagement/fareMedia/`
      )
    } catch (error) {
      if (error && error.response && error.response.data && error.response.data.message) {
      
        toast.error(`${error.response.data.message}`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
        });
      } else {
       
        toast.error(`${error}`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <Box sx={{ marginTop: -5, padding: 4 }}>
        <Typography sx={{ color: '#252733', fontWeight: 'bold', marginBottom: '16px' }}>
          {intl.formatMessage({ id: 'EditFareMedia' })}
        </Typography>

        {isFormLoading ? (
          <CircularProgress style={{ display: "block" }} />
        ) : (
error != null ? <h4 style={{textAlign:"center"}}>{intl.formatMessage({ id: 'somethingWrong' })}</h4>:
          <Box component="form" onSubmit={handleSubmit}>
            <div className='parent-form'>
              <div>
                <label className='labelStyle'>{intl.formatMessage({ id: 'uid' })}</label>
                <input
                  type="text"
                  className='inputStyle'
                  id="uid"
                  value={uid}
                  disabled
                />

                <label className='labelStyle'>{intl.formatMessage({ id: 'serial_num' })}</label>
                <input
                  type="text"
                  className='inputStyle'
                  id="serialNumber"
                  value={serial_num}
                  disabled
                />
                <label className='labelStyle'>{intl.formatMessage({ id: 'init_balance' })}</label>
                <input
                  type="number"
                  min="0"
                  step="any"
                  className='inputStyle'
                  id="init_balance"
                  value={init_balance}
                  disabled
                />
                <label className='labelStyle'>{intl.formatMessage({ id: 'selling_price' })}</label>
                <input
                  type="number"
                  min="0"
                  step="any"
                  className='inputStyle'
                  id="selling_price"
                  value={selling_price}
                  disabled
                />

           {from_portal != false ? 
           <>
                    <label className='labelStyle'
              >{intl.formatMessage({ id: 'is_blacklisted' })}</label>
              <input
               style={{margin:"10px -5px",padding:"10px",width:"40px"}}
                type="checkbox"
                checked={is_blacklist}
                onChange={(e) => setis_blacklist(e.target.checked)}
              />   <br></br>
             { is_blacklist && <>
                <label className='labelStyle'>{intl.formatMessage({ id: 'Blacklisted_note' })} </label>
                <textarea  name="blacklist_note" rows="4" cols="50"
                onChange={(e) => setblacklist_note(e.target.value)}
                  className='inputStyle'
                >
                  {blacklist_note}
               </textarea>
               </>}
               </> : <h6 style={{fontSize:"11px"}}>* {intl.formatMessage({ id: 'Not_Allowed_to_edit' })}</h6>}

                {/* v7: passenger group is user-level now — not editable on the card. */}
              </div>
              <div>     <label className='labelStyle'>{intl.formatMessage({ id: 'type' })}</label>
                {fareMediaTypesLoading ? (
                  <CircularProgress size={24} sx={{ display: "block" }} />
                ) : (
                  <input
                    type="text"
                    className='inputStyle'
                    id="fareMediaType"
                    value={
                      currentLanguageCode === "en-us"
                        ? fareMediaTypes.find((f) => f.id === fare_media_type_id)?.en_name || ''
                        : fareMediaTypes.find((f) => f.id === fare_media_type_id)?.ar_name || ''
                    }
                    disabled
                  />
                )}
                <label className='labelStyle'>{intl.formatMessage({ id: 'issuer_name' })}</label>
                {fareMediaIssuersLoading ? (
                  <CircularProgress size={24} sx={{ display: "block" }} />
                ) : (
                  <input
                    type="text"
                    className='inputStyle'
                    id="fareMediaIssuers"
                    value={
                      currentLanguageCode === 'en-us'
                        ? fareMediaIssuers.find((i) => i.id === fare_media_issuer_id)?.en_issuer_name || ''
                        : fareMediaIssuers.find((i) => i.id === fare_media_issuer_id)?.ar_issuer_name || ''
                    }
                    disabled
                  />
                )}
                <label className='labelStyle'>{intl.formatMessage({ id: 'organization' })}</label>
                {organisationsLoading ? (
                  <CircularProgress size={24} sx={{ display: "block" }} />
                ) : (
                  <input
                    type="text"
                    className='inputStyle'
                    id="organisations"
                    value={
                      currentLanguageCode === 'en-us'
                        ? organisations.find((o) => o.id === organisation_id)?.en_name || ''
                        : organisations.find((o) => o.id === organisation_id)?.ar_name || ''
                    }
                    disabled
                  />
                )} 


                <label className='labelStyle'>{intl.formatMessage({ id: 'fare_media_batch_label' })}</label>
                <input
                  type="text"
                  className='inputStyle'
                  value={fare_media_batch_label}
                  disabled
                />

              </div>
            </div>
            {/* v7: group-change reason removed — group is user-level, not changed on the card. */}
            <div sx={{ marginBottom: 2, display: "block" }}>
              <button
                type="submit"
                className='updateBtnStyle'
                disabled={isLoading}
              >
                {isLoading ? intl.formatMessage({ id: 'Updating' }) : intl.formatMessage({ id: 'update' })}
              </button>
              <button
                className='cancelBtnStyle'
                onClick={() => 
                  history.push( came_from && came_from == "one" 
                  ? `/CardsManagement/fareMedia/${id}`:
                  `/CardsManagement/fareMedia/`
                )}
              >
                {intl.formatMessage({ id: 'Back' })}
              </button>
            </div>
          </Box>

        )}
      </Box>
      <ToastContainer />
    </>
  );
};

export default EditFareMedia;
